import Vue from "vue";
import store from "./store/index";
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import InfiniteLoading from 'vue-infinite-loading';
import VueClipboard from 'vue-clipboard2';

import AutoHeight from './components/auto-height';
import FlashMessageViewer from './components/flash-message';
import Chat from './components/chat/chat';
import ContactSelect from './components/contact-select';
import Widget from './components/widget';
import InputDebounced from './components/input-debounced';
import SelectFilter from './components/filter/v1/select-filter';
import RemoteSelectFilter from './components/filter/v1/remote-select-filter';
import DependentSelectFilter from './components/filter/v1/dependent-select-filter';
import TextFilter from './components/filter/v1/text-filter';
import CheckBoxFilter from './components/filter/v1/checkbox-filter';
import DateRangeFilter from "./components/filter/v1/date-range-filter";
import SendListCreateForm from './pages/send-list-create/form-wrapper';
import SendListUpdateForm from './pages/send-list-update/form-wrapper';
import SendListImportFrom from './pages/send-list-create-import/form-wrapper';
import ConversationIndexPage from './pages/conversation/index';
import ConversationListOnEditSendListPage from './pages/send-list-update/conversation-list';
import AddItemPanelOnEditSendListPage from './pages/send-list-update/add-item-panel';
import ExportPanelOnEditSendListPage from './pages/send-list-update/export-panel';
import BulkMessageForm from './components/bulk-message/form';
import QuickChatMessage from './quick-message/quick-message';
import QuickBulkMessage from './components/bulk-message/quick-message';
import QuickMessageMenuItem from './quick-message/quick-message-menu-item';
import ChatOnConversationsPage from './pages/conversation-list/chat.vue';
import ConversationListOnConversationsPage from './pages/conversation-list/conversation-list';
import ModalEditSendListConversationForm from './components/shared/send-list-conversation/edit-item/dialog';
import ModalAddSendListConversationForm from './components/shared/send-list-conversation/add-item/dialog';
import BrandToggle from './components/shared/brand-toggle/brand-toggle';
import BrandIndexPage from './pages/brand/index';
import ImportTableOnImportPage from './pages/import/import-table';
import CampaignTemplateIndexPage from './pages/campaign-template/index';
import DoNotContactIndexPage from './pages/do-not-contact/index';
import ContactListIndexPage from './pages/contact-list-index/index';
import ContactHoldIndexPage from './pages/contact-hold/index';
import CampaignIndexPage from './pages/campaign/index';
import CampaignSchedulingIndexPage from './pages/campaign-scheduling/index';
import SettingIndexPage from './pages/setting/index';
import OutgoingNumberIndexPage from './pages/outgoing-number/index';
import CallDialog from './components/call/call-dialog';
import CallStatus from './components/call/online-status';
import ContactIndexPage from './pages/contact/index';
import AudioIndexPage from './pages/audio/index';
import MessageLagReport from './reports/messages-lag/index';
import OutgoingTextReport from './reports/outbound-texts/index';
import InboundTextReport from './reports/inbound-texts/index';
import CallsReport from './reports/calls/index';
import EmailsSentReport from './reports/emails-sent/index';
import GroupEmailReport from './reports/group-emails-sent/index';
import DailyActivityReport from './reports/daily-activity/index';
import ModalQuickAddToSendList from './components/shared/send-list-conversation/quick-add/dialog.vue';
import SendListIndexPage from './pages/send-list/table/index';
import SendListListPage from './pages/send-list/list/index';
import UserIndexPage from './pages/user/index';
import RoleTablePage from './pages/role/table/index';
import WhitelistIpTablePage from './pages/whitelist-ip/table/index';
import BulkMessageTablePage from './pages/bulk-message/table/index';
import DatabaseIndexPage from './pages/database/index';
import OptEventTablePage from './pages/opt-event/table/index';
import ProviderTablePage from './pages/provider/table/index';
import ApprovedMessageTablePage from './pages/approved-message/table/index';
import NotificationCenter from './components/notification-center';
import RepresentativeTablePage from './pages/representative/table/index';
import EmailAddressTablePage from './pages/email-address/table/index';
import ForwardingAddressTablePage from './pages/forwarding-address/table/index';
import EmailQuarantineTablePage from './pages/email-quarantine/table/index';
import TagTablePage from './pages/tag/table/index';

import SmsSendBox from './components/chat/send-boxes/sms';
import MailSendBox from './components/chat/send-boxes/mail';

import eventBus from './event-bus';

import {trim, uppercase} from './filters';

window.Vue = require('vue');

Vue.use(ElementUI, {locale});
Vue.use(InfiniteLoading);
Vue.use(VueClipboard);

Vue.component('auto-height', AutoHeight);
Vue.component('flash-message-viewer', FlashMessageViewer);
Vue.component('chat', Chat);
Vue.component('contact-select', ContactSelect);
Vue.component('widget', Widget);
Vue.component('input-debounced', InputDebounced);
Vue.component('select-filter', SelectFilter);
Vue.component('remote-select-filter', RemoteSelectFilter);
Vue.component('dependent-select-filter', DependentSelectFilter);
Vue.component('text-filter', TextFilter);
Vue.component('checkbox-filter', CheckBoxFilter);
Vue.component('date-range-filter', DateRangeFilter);
Vue.component('send-list-create-form', SendListCreateForm);
Vue.component('send-list-update-form', SendListUpdateForm);
Vue.component('conversation-index-page', ConversationIndexPage);
Vue.component('conversation-list-on-edit-send-list-page', ConversationListOnEditSendListPage);
Vue.component('add-item-panel-on-edit-send-list-page', AddItemPanelOnEditSendListPage);
Vue.component('export-panel-on-edit-send-list-page', ExportPanelOnEditSendListPage);
Vue.component('bulk-message-form', BulkMessageForm);
Vue.component('quick-chat-message', QuickChatMessage);
Vue.component('quick-messages-menu-item', QuickMessageMenuItem);
Vue.component('chat-on-conversations-page', ChatOnConversationsPage);
Vue.component('conversation-list-on-conversations-page', ConversationListOnConversationsPage);
Vue.component('modal-edit-send-list-conversation-form', ModalEditSendListConversationForm);
Vue.component('modal-add-send-list-conversation-form', ModalAddSendListConversationForm);
Vue.component('quick-bulk-message', QuickBulkMessage);
Vue.component('brand-toggle', BrandToggle);
Vue.component('brand-index-page', BrandIndexPage);
Vue.component('import-table-on-import-page', ImportTableOnImportPage);
Vue.component('campaign-template-index-page', CampaignTemplateIndexPage);
Vue.component('do-not-contact-index-page', DoNotContactIndexPage);
Vue.component('contact-hold-index-page', ContactHoldIndexPage);
Vue.component('contact-list-index-page', ContactListIndexPage);
Vue.component('campaign-index-page', CampaignIndexPage);
Vue.component('campaign-scheduling-index-page', CampaignSchedulingIndexPage);
Vue.component('setting-index-page', SettingIndexPage);
Vue.component('outgoing-number-index-page', OutgoingNumberIndexPage);
Vue.component('call-dialog', CallDialog);
Vue.component('call-status', CallStatus);
Vue.component('contact-index-page', ContactIndexPage);
Vue.component('audio-index-page', AudioIndexPage);
Vue.component('message-lag-report', MessageLagReport);
Vue.component('outgoing-text-report', OutgoingTextReport);
Vue.component('inbound-text-report', InboundTextReport);
Vue.component('calls-report', CallsReport);
Vue.component('emails-sent-report', EmailsSentReport);
Vue.component('group-emails-sent-report', GroupEmailReport);
Vue.component('daily-activity-report', DailyActivityReport);
Vue.component('modal-quick-add-to-send-list', ModalQuickAddToSendList);
Vue.component('send-list-index-page', SendListIndexPage);
Vue.component('send-list-list-page', SendListListPage);
Vue.component('send-list-import-page', SendListImportFrom);
Vue.component('user-index-page', UserIndexPage);
Vue.component('role-table-page', RoleTablePage);
Vue.component('whitelist-ip-table-page', WhitelistIpTablePage);
Vue.component('bulk-message-table-page', BulkMessageTablePage);
Vue.component('database-index-page', DatabaseIndexPage);
Vue.component('opt-event-table-page', OptEventTablePage);
Vue.component('provider-table-page', ProviderTablePage);
Vue.component('approved-message-table-page', ApprovedMessageTablePage);
Vue.component('notification-center', NotificationCenter);
Vue.component('representative-table-page', RepresentativeTablePage);
Vue.component('email-address-table-page', EmailAddressTablePage);
Vue.component('forwarding-address-table-page', ForwardingAddressTablePage);
Vue.component('email-quarantine-table-page', EmailQuarantineTablePage);
Vue.component('tag-table-page', TagTablePage);

Vue.component('sms', SmsSendBox);
Vue.component('mail', MailSendBox);

Vue.filter('uppercase', uppercase);
Vue.filter('trim', trim);

window.eventBus = eventBus;

export default new Vue({
  el: '#app',
  store,
  mounted() {
    this.$store.dispatch('voice/init');
  },
});
